<template>
  <div>
    <div class="block"></div>
    <div class="wrap" id="app-footer">
      <!-- <router-link to="" class="item">
        <div class="divLists" @click="tabActive(0)" v-if='tab === 0'>
          <img src="../assets/imgq/home1.png" alt="" class="footimg">
          <p class="footTxt baseColor">首页</p>
        </div>
        <div class="divLists" @click="tabActive(0)" v-if='tab != 0'>
          <img src="../assets/imgq/home0.png" alt="" class="footimg">
          <p class="footTxt">首页</p>
        </div>
      </router-link> -->
     <router-link to="/" class="item">
        <div class="divLists" @click="tabActive(1)" v-if='tab === 1'>
          <img src="../assets/newicon/sangcheng.png" alt="" class="footimg">
          <p class="footTxt baseColor">商城</p>
        </div>
        <div class="divLists" @click="tabActive(1)" v-if='tab != 1'>
          <img src="../assets/newicon/sangcheng01.png" alt="" class="footimg">
          <p class="footTxt">商城</p>
        </div>
      </router-link>
      <!-- <router-link to="/store" class="item">
        <div class="divLists" @click="tabActive(1)" v-if='tab === 1'>
          <img src="../assets/imgq/store1.png" alt="" class="footimg">
          <p class="footTxt baseColor">商城</p>
        </div>
        <div class="divLists" @click="tabActive(1)" v-if='tab != 1'>
          <img src="../assets/imgq/store0.png" alt="" class="footimg">
          <p class="footTxt">商城</p>
        </div>
      </router-link> -->
      <div @click="goBuyCar" class="item">
        <div class="divLists" @click="tabActive(2)" v-if='tab === 2'>
          <img src="../assets/newicon/shoppingcart.png" alt="" class="footimg">
          <p class="footTxt baseColor">购物车</p>
        </div>
        <div class="divLists" @click="tabActive(2)" v-if='tab != 2'>
          <img src="../assets/newicon/shoppingcart01.png" alt="" class="footimg">
          <p class="footTxt">购物车</p>
        </div>
      </div>
      
      <div @click="goMine" class="item">
        <div class="divLists" @click="tabActive(3)" v-if='tab === 3'>
          <img src="../assets/newicon/gerenzhongxing.png" alt="" class="footimg">
          <p class="footTxt baseColor">个人中心</p>
        </div>
        <div class="divLists" @click="tabActive(3)" v-if='tab != 3'>
          <img src="../assets/newicon/gerenzhongxing01.png" alt="" class="footimg">
          <p class="footTxt">个人中心</p>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
	import util from '../utils/util';
	import axios from 'axios';
	import $ from '../utils/axios';
import { Toast } from 'vant';
  export default {
    name: 'app-footer',
    data () {
      return {
        tab:1
      }
    },
    methods:{
      goMine() {
        if(Number(sessionStorage.getItem('ShenHeStatus')) !== 3) return  Toast('请先申请成为该经销商授权客户')
        this.$router.push('/mine')
      },
      goBuyCar() {
        if(Number(sessionStorage.getItem('ShenHeStatus')) !== 3) return  Toast('请先申请成为该经销商授权客户')
        this.$router.push('/buyCar')
      },
      tabActive(e) {
        this.tab = e;
      },
      getAds(){
        $.post('Authorize/RelationShop_DMS',{}).then(res => {
          var allinfo = util.getStoObj('allinfo');
          if(allinfo){
            allinfo.IsADS = res.Data.IsADS;
            util.setStoObj('allinfo',allinfo);
          }
        })
      }
    },
    mounted() {
      // this.getAds();
    }
  }
</script>

<style scoped lang="scss">
.block{
  width: 100%;
  height: 0.98rem;
}
#app-footer{
  z-index: 2;
  background: #fff;
  padding: 0.25rem 0;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .divLists{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .item{
    width: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .footimg{
      width: 0.5rem;
      height: 0.44rem;
      margin-bottom: 0.02rem;
    }
    .footTxt{
      font-size: 0.24rem;
    }
  }
  
}
</style>